export const fetchCreativePreviewInfo = (creativeIds) => {
  if (creativeIds) {
    return fetch(
      process.env.REACT_APP_API_URL +
        `/api/sql/creativePreviewInfo?creativeIds=${creativeIds.toString()}`
    )
      .then(
        (response) => response.json(),
        (error) => console.log("An error occurred.", error)
      )
      .then((json) => {
        return json;
      });
  } else {
    return [];
  }
};
